export default "__VITE_ASSET__C84z$Fug__"